import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpClientJsonpModule } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppTokenHandler } from '../Common/app-token-handler';
import { Router } from '@angular/router';
import { AzureADAuthService } from './azureadauth.service';
//import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Injectable()
export class DataService {
    private apiUrl: string;
    private httpDataServiceOptions: any;
    private httpHeaderFileDownload: any;
    private httpHeaderFileUpload: any;
    referralURL: string;
    roleList: string[];

    isRole = false;
    constructor(private appToken: AppTokenHandler, private http: HttpClient, private route: Router,

    ) {
        this.apiUrl = environment.serviceBaseUrl;
        this.httpHeaderFileDownload = {
            headers: new HttpHeaders({
                access_token: this.appToken.getSessionToken()
            }),
            responseType: 'blob',
            withCredentials: true
        };
        this.httpHeaderFileUpload = {
            headers: new HttpHeaders({
                access_token: this.appToken.getSessionToken()
            }),
            withCredentials: true
        };
    }

    Login(Email: string = '', AzureToken: string = '') {
        const body: any = null;
        const httpOptions = {
            headers: new HttpHeaders({ azure_token: AzureToken }), withCredentials: true
        }
        return this.http.get(environment.tokenPath, httpOptions).pipe(catchError(this.handleError));
    }
    GetData(_url: string) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    GetDataById(_url: string, _id: string) {
        _url = environment.serviceBaseUrl + _url + '/' + _id;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    PostData(_url: string, _postdata: any) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.post(_url, _postdata, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    private handleError(error: Response) {
        console.log("From Common Service: "+ error)
        return throwError(error);
    }
    postfile(url, formData) {
        return this.http.post<any>(this.apiUrl + url, formData, this.httpHeaderFileUpload)
            .pipe(catchError(this.handleError)
        );
    }
    ContainsSpecialCharacters(searchString: string) {
        let IsValidString = true;
        if (searchString.length > 0) {
            const regex = /^[A-Za-z0-9 ]+$/;
            IsValidString = regex.test(searchString);
        }
        return (IsValidString === true ? false : true);
    }
    LogoutUser(_url: string) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    DownloadFile(url) {
        return this.http.get(this.apiUrl + url, this.httpHeaderFileDownload)
            .pipe(catchError(this.handleError)
        );
    }
    PostDownload(Url: string, param: any,) {
        return this.http.post(this.apiUrl + Url, param, this.httpHeaderFileDownload)
            .pipe(catchError(this.handleError));
    }
    DownloadFileWithPost(url, formData) {
        return this.http.post(this.apiUrl + url, formData, this.httpHeaderFileDownload)
            .pipe(catchError(this.handleError)
        );
    }
    GetVisitPath(_url: string) {
        _url = _url;
        return this.http.post(_url, this.httpHeaderFileDownload).pipe(catchError(this.handleError));
    }
    LogPageAnalytics(url) {
        return this.http.jsonp(url, "JSONP_CALLBACK")
            .pipe(catchError(this.handleError));
    }
    GetUserDetails(url: string, ExpectedRole: any, azure_token: any = '') {
        if (this.appToken.getSessionToken().length <= 0) {
            //this.spinnerService.show();
            this.Login('', azure_token).subscribe((data: any) => {
                if (data.IsAuthenticated) {
                    this.appToken.setSessionToken(data);
                    // this.route.navigate(['/home']);
                    this.referralURL = url;
                    if (this.referralURL == null) {
                        this.route.navigate(['/dashboard']);
                    } else {
                        this.isRole = false;
                        this.roleList = data.Roles.split(',');
                        ExpectedRole.forEach(element => {
                            if (data.IsAuthenticated && this.roleList.indexOf(element) >= 0) {
                                this.isRole = true;
                            }
                        });
                        if (!this.isRole) {
                            this.route.navigate(['/error/4']);
                            return false;
                        } else {
                            this.route.navigate([this.referralURL]);
                            this.referralURL = null;
                        }
                    }
                } else {
                    this.route.navigate(['/error/1']);
                }
            }, (error: Response) => {
                console.log("GetUserDetails from data.service: "+ error);
                if (error.status <= 0) {
                    this.route.navigate(['/error/2']);
                } else if (error.status === 401) {
                    this.route.navigate(['/error/1']);
                } else {
                    this.route.navigate(['/error/2']);
                }
            }, () => {
                //this.spinnerService.hide();
            });
        } else {
            // this.route.navigate(['/home']);
            this.route.navigate(['/dashboard']);
        }
    }
}

@Injectable()
export class UIBlockingStatus {
    private IsBlocked: BehaviorSubject<boolean>;
    constructor() {
        this.IsBlocked = new BehaviorSubject(false);
    }

    setStatus(_IsBlocked: boolean) {
        this.IsBlocked.next(_IsBlocked);
    }

    getStatus(): Observable<boolean> {
        return this.IsBlocked.asObservable();
    }




}
